module.exports = __webpack_public_path__ + "static/img/6.55ad9f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/6.png
// module id = RsTb
// module chunks = 0